// cc-web-learning/src/Hooks/FairPlayApi/useFairplayAppealApi.js
//
// FairPlay Phase 3 — Appeal / Mark-as-Read hook (web version, JS).
// Mirrors cc-learning-app/src/Hooks/FairPlayApi/useFairplayAppealApi.ts
// Endpoint: POST fairplay/v1/fairplay_appeal_triggered/

import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useFairplayAppealApi(
  handleOnSuccess,
  handleOnError,
) {
  return useMutation(
    async payload => {
      const response = await ChessRestClient.post(
        'fairplay/v1/fairplay_appeal_triggered/',
        payload,
      );
      console.log('[FairPlay] appeal response =', response.data);
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        console.error('[FairPlay] fairplay_appeal_triggered failed:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
